import { isMetafieldValueTrue } from '../utils/metafield-utils';

export const getConvertedCategoryFields = (category) => {
  const heroFontIsDarkValue = isMetafieldValueTrue(category?.heroFontIsDark?.value);

  return {
    ...category,
    heroFontIsDark: heroFontIsDarkValue,
    // future dataType conversions
  };
};
